import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";


function Toolbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
const navigate = useNavigate();
  useEffect(() => {
    // 🔍 check token from localStorage
    const token = localStorage.getItem("token");
    if (token && token !== "null" && token !== "undefined") {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <>
      {/* 🔴 Before Login */}
      {!isLoggedIn && (
        <div className="bottom-navigator d-md-none">
          <div className="row bottom-navigator-before-login no-gutters">
            <div
              className="bottom-navigator-before-login-first d-flex justify-center align-center no-gutters col col-6"
               onClick={() => navigate("/signup")}
            >
              <b>JOIN NOW</b>
            </div>
            <div
              className="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters col col-6"
               onClick={() => navigate("/login")}
            >
              <b>LOGIN</b>
            </div>
          </div>
        </div>
      )}

      {/* 🟢 After Login */}
      {isLoggedIn && (
        <div className="mobile-navigator hidden-md-and-up">
          <div className="row no-gutters">
            <div className="grow col col-auto">
              <Link to="/promotion" className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--dark v-size--default" style={{height: 'auto'}}>
                <span className="v-btn__content">
                  <div className="text-center">
                    <img alt="" src="./static/svg/mobileBottomNavigation/promotion.svg" className="icon_btm_nav" />
                    <p>Promotion</p>
                  </div>
                </span>
              </Link>
            </div>

            {/* <div className="grow col col-auto">
              <Link to="/rebate" className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--dark v-size--default" style={{height: 'auto'}}>
                <span className="v-btn__content">
                  <div className="text-center">
                    <img alt="" src="./static/svg/mobileBottomNavigation/instantRebate.svg" className="icon_btm_nav rebateicon" />
                    <p>Rebate</p>
                  </div>
                </span>
              </Link>
            </div> */}

            <div className="grow col col-auto">
              <Link to="/" className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--dark v-size--default" style={{height: 'auto'}}>
                <span className="v-btn__content">
                  <div className="text-center">
                    <img alt="" src="./static/svg/mobileBottomNavigation/home.svg" className="icon_btm_nav" />
                    <p>Home</p>
                  </div>
                </span>
              </Link>
            </div>

            <div className="grow col col-auto">
              <Link to="/deposit" className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--dark v-size--default" style={{height: 'auto'}}>
                <span className="v-btn__content">
                  <div className="text-center">
                    <img alt="" src="./static/svg/mobileBottomNavigation/deposit.svg" className="icon_btm_nav" />
                    <p>Deposit</p>
                  </div>
                </span>
              </Link>
            </div>

            <div className="grow col col-auto">
              <Link to={'/account'}  className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--dark v-size--default" style={{height: 'auto'}}>
                <span className="v-btn__content">
                  <div className="text-center">
                    <img alt="" src="./static/svg/mobileBottomNavigation/account.svg" className="icon_btm_nav" />
                    <p>Account</p>
                  </div>
                </span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Toolbar;
